module.exports = __webpack_public_path__ + "static/media/LK_Cheveron_Down.2b115f2b.svg";